import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import FeaturedComics from "./components/FeaturedComics";
import HotRanking from "./components/HotRanking";
import LatestUpdates from "./components/LatestUpdates";

export default function Home() {
  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "韩漫漫画网站",
    url: window.location.origin,
    description:
      "韩漫漫画网站 —— 韩漫在线观看与免费韩国漫画下拉式阅读平台，一站式满足您的所有观看需求。",
    potentialAction: {
      "@type": "SearchAction",
      target: `${window.location.origin}/category/all?search={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  };

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "韩漫漫画网站",
    url: window.location.origin,
    description:
      "韩漫在线观看平台，提供免费韩国漫画下拉式阅读服务。",
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "韩漫漫画网站可以免费观看吗？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "是的，韩漫漫画网站提供免费韩国漫画下拉式阅读，无需付费即可享受海量韩漫资源。",
        },
      },
      {
        "@type": "Question",
        name: "韩漫在线观看需要注册账号吗？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "不需要注册，直接访问漫画韩漫网址即可开始韩漫在线观看，方便快捷。",
        },
      },
      {
        "@type": "Question",
        name: "网站上的漫画多久更新一次？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "我们每日更新最新韩漫章节，确保读者能够第一时间追更喜爱的免费韩国漫画。",
        },
      },
      {
        "@type": "Question",
        name: "支持哪些类型的韩漫？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "韩漫漫画网站涵盖恋爱、奇幻、动作、悬疑、搞笑、日常、BL等多种类型，满足不同读者的口味需求。",
        },
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(websiteSchema),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(organizationSchema),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(faqSchema),
        }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedComics />
        <HotRanking />
        <LatestUpdates />
      </main>
      <Footer />
    </>
  );
}